import { h, Component } from 'preact';
import Widget from '../components/Widget';
import MobileHub from '../components/MobileHub';
import { animate, interpolate } from '../../helpers/utils/motion';
import './index.css';

export default class Mobile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
      isFlashMode: false,
      flashEcm: null,
      bus: props.bus,
      ecmStorage: props.ecmStorage,
      updated: Date.now(),
      index: 1,
    };
    this.move = this.move.bind(this);
  }

  componentDidMount() {
    this.props.setComponent(this);
  }

  addEcm = (ecm) => {
    this.setState((state) => {
      ecm = state.ecmStorage.create(ecm);
      return { updated: Date.now() };
    });
  };

  removeEcm = (ecm) => {
    this.setState((state) => {
      state.ecmStorage.delete(ecm.id);
      return { updated: Date.now() };
    });
  };

  onOpenWidget = () => {
    this.setState(function (state) {
      state.ecmStorage.updateAll({ seen: true });
      return { isOpen: true };
    });
  };

  move(direction) {
    let { index } = this.state;
    const { ecmStorage } = this.state;
    const ecmList = ecmStorage.all();

    index += -direction;
    if (index < 0 || index > ecmList.length - 1) {
      return;
    }
    const width = document.body.offsetWidth;
    const x = (width - 290) / 2 + index * -290;
    const element = document.getElementById('beans-snow-mobilehub-component-mobile-toasts');
    const { transform } = getComputedStyle(element);
    // eslint-disable-next-line no-useless-escape
    const translateX = transform.match(/(-?[0-9\.]+)/g).map((i) => +i)[4];

    this.setState({ index }, function () {
      animate({
        duration: 200,
        easing: 'quadIn',
        targets: '#beans-snow-mobilehub-component-mobile-toasts',
        styles: {
          transform: (t) => `translateX(${interpolate(translateX, x, t)}px)`,
        },
      });
    });
  }

  render() {
    const { display } = this.props;
    const { isOpen, index, ecmStorage } = this.state;

    const ecmList = ecmStorage.all();
    const badge = ecmList.filter((ecm) => !ecm.seen).length;

    const color = display.color || '#0278D1';
    const position = display.h_position || 'left';

    return (
      <div id="beans-snow-mobile-widget-container" className={position} style="z-index: 2147483647;padding: 0px;">
        {isOpen ? (
          <div id="beans-snow-mobile-mobile-hub-container">
            <div id="beans-snow-mobile-mobile-hub-content">
              <MobileHub
                ecmList={ecmList}
                index={index}
                defaultColor={color}
                bus={this.state.bus}
                onSwiperight={this.move}
                onSwipeleft={this.move}
              />
              <div style="display: flex;justify-content: center;transform: translateY(15px);">
                <button
                  type="button"
                  onClick={() => this.move(1)}
                  id="beans-snow-mobile-nav-left"
                  style={{ zIndex: 2147483647 - 3, opacity: index > 0 ? '1' : '0.5' }}
                  disabled={index <= 0}
                >
                  <svg width="15" height="10" viewBox="0 0 15 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M14 5H1M1 5L6.52212 1M1 5L6.52212 9"
                      stroke="#2F2F2F"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </button>
                <div id="beans-snow-mobile-close-container">
                  <button
                    type="button"
                    onClick={() => this.setState({ isOpen: false })}
                    id="beans-snow-mobile-mobile-close-btn"
                  >
                    <svg
                      style="margin-right: 4px;"
                      width="12"
                      height="12"
                      viewBox="0 0 12 12"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M1.00014 1.0918L10.4935 10.5262M10.4934 1.15091L1 10.5853"
                        stroke="white"
                        strokeWidth="1.61741"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                    Close
                  </button>
                </div>
                <button
                  type="button"
                  onClick={() => this.move(-1)}
                  id="beans-snow-mobile-nav-right"
                  style={{
                    zIndex: 2147483647 - 3,
                    opacity: index < ecmList.length - 1 ? '1' : '0.5',
                  }}
                  disabled={index >= ecmList.length - 1}
                >
                  <svg width="16" height="10" viewBox="0 0 16 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M1 5H15M15 5L9.0531 1M15 5L9.0531 9"
                      stroke="#2F2F2F"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </button>
              </div>
            </div>
          </div>
        ) : (
          <div id="beans-snow-mobile-widget-base">
            {badge > 0 ? <div id="beans-snow-mobile-badge">{badge}</div> : null}
            <Widget display={display} active={isOpen} onClick={this.onOpenWidget} />
          </div>
        )}
      </div>
    );
  }
}
